import Vue from 'vue'
import Router from 'vue-router'
import { Loading, Message, MessageBox } from 'element-ui';
import Util from '../libs/util.js';
import { getToken } from '../utils/auth';
import store from '../store';
import Main from '@/views/Main.vue';

Vue.use(Router)

export const router = new Router({
  routes: [
    {
      path: '/',
      component: Main,
      redirect: '/home',
      children: [
        {
          path: 'home',
          name: 'home',
          meta: {
            title: '首页'
          },
          component: () => import('@/views/home')
        }
      ]
    },
    // 回调页面
    {
      path: '/callBack',
      name: 'callBack',
      meta: {
        title: '回调页面'
      },
      component: () => import('@/views/openAccount/components/callBackPage')
    },
    // 回调页面
    {
      path: '/enterpriseCallBackPage',
      name: 'EnterpriseCallBackPage',
      meta: {
        title: '回调页面'
      },
      component: () => import('@/views/openAccount/components/enterpriseCallBackPage')
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录'
      },
      component: () => import('@/views/login')
    },
    // 开户列表
    {
      path: '/openAccount',
      component: Main,
      redirect: '/openAccount/list',
      children: [
        {
          path: 'list',
          meta: {
            title: '个人开户列表'
          },
          name: 'openAccountList',
          component: () => import('@/views/openAccount/index.vue')
        },
        {
          path: 'enterpriseOpenAccountList',
          meta: {
            title: '企业开户列表'
          },
          name: 'enterpriseOpenAccountList',
          component: () => import('@/views/openAccount/enterpriseOpenAccountList.vue')
        },
        {
          path: 'enterpriseOpenAccountList/enterpriseStep',
          meta: {
            title: '企业开户步骤'
          },
          name: 'enterpriseStep',
          component: () => import('@/views/openAccount/components/enterpriseStep.vue')
        },
        {
          path: 'list/openDetail',
          meta: {
            title: '开户详情页'
          },
          name: 'openDetail',
          component: () => import('@/views/allinpayAccount/openDetail.vue')
        },
        {
          path: 'list/openEdit',
          meta: {
            title: '开户编辑页'
          },
          name: 'openEdit',
          component: () => import('@/views/allinpayAccount/openDetail.vue')
        },
        {
          path: 'messagePush',
          meta: {
            title: '开户推送管理'
          },
          name: 'messagePush',
          component: () => import('@/views/openAccount/messagePush')
        }
      ]
    },
    // 通商云用户管理
    {
      path: '/allinpayAccount',
      component: Main,
      redirect: '/allinpayAccount/list',
      children: [
        {
          path: 'list',
          meta: {
            title: '通联个人用户列表'
          },
          name: 'allinpayAccount',
          component: () => import('@/views/allinpayAccount/index.vue')
        },
        {
          path: 'enterpriseAllinpayAccountList',
          meta: {
            title: '通联企业用户列表'
          },
          name: 'enterpriseAllinpayAccount',
          component: () => import('@/views/allinpayAccount/enterpriseAllinpayAccount.vue')
        },
        {
          path: 'list/userDetail',
          meta: {
            title: '通商云用户详情页'
          },
          name: 'userDetail',
          component: () => import('@/views/allinpayAccount/openDetail.vue')
        },
        {
          path: 'list/userEdit',
          meta: {
            title: '通商云用户编辑页'
          },
          name: 'userEdit',
          component: () => import('@/views/allinpayAccount/openDetail.vue')
        }
      ]
    },
    // 资金管理
    {
      path: '/capitalManagement',
      component: Main,
      redirect: '/capitalManagement/list',
      children: [
        {
          path: 'list',
          meta: {
            title: '现金缴存记录'
          },
          name: 'capitalManagementList',
          component: () => import('@/views/capitalManagement/index.vue')
        },
        {
          path: 'checkExport',
          meta: {
            title: '对帐导出'
          },
          name: 'checkExport',
          component: () => import('@/views/capitalManagement/checkExport.vue')
        }
      ]
    },
    // 财务报表
    {
      path: '/financialReport',
      component: Main,
      redirect: '/financialReport/financialReport',
      children: [
        {
          path: 'reportPush',
          meta: {
            title: '股东推送'
          },
          name: 'financialList',
          component: () => import('@/views/financialReport/reportPush.vue')
        },
        {
          path: 'financialDetail',
          meta: {
            title: '门店报表'
          },
          name: 'financialDetail',
          component: () => import('@/views/financialReport/financialDetail.vue')
        },
        {
          path: 'reportAudit',
          meta: {
            title: '报表审核'
          },
          name: 'reportAudit',
          component: () => import('@/views/financialReport/reportAudit.vue')
        }
      ]
    },

    // 转账管理
    {
      path: '/transferManagement',
      component: Main,
      redirect: '/transferManagement/list',
      children: [
        {
          path: 'list',
          meta: {
            title: '待发起',
            keepAlive: true
          },
          name: 'transferManagementList',
          component: () => import('@/views/transferManagement/index.vue')
        },
        {
          path: 'auditList',
          meta: {
            title: '审核',
            keepAlive: true
          },
          name: 'auditList',
          component: () => import('@/views/transferManagement/auditList.vue')
        },
        {
          path: 'waitPaymentList',
          meta: {
            title: '付款列表',
            keepAlive: true
          },
          name: 'waitPaymentList',
          component: () => import('@/views/transferManagement/waitPaymentList.vue')
        },
        {
          path: 'historicalTransferBill',
          meta: {
            title: '历史转账单'
          },
          name: 'historicalTransferBill',
          component: () => import('@/views/transferManagement/historicalTransferBill.vue')
        },
        {
          path: 'detailsList',
          meta: {
            title: '详情'
          },
          name: 'detailsList',
          component: () => import('@/views/transferManagement/components/detailsList.vue')
        },
        {
          path: 'historicalDetailsList',
          meta: {
            title: '历史转账单详情'
          },
          name: 'historicalDetailsList',
          component: () => import('@/views/transferManagement/components/historicalDetailsList.vue')
        },
        {
          path: 'rejectionBox',
          meta: {
            title: '驳回箱'
          },
          name: 'rejectionBox',
          component: () => import('@/views/transferManagement/rejectionBox.vue')
        },
        {
          path: 'withdrawList',
          meta: {
            title: '提现列表',
            keepAlive: true
          },
          name: 'withdrawList',
          component: () => import('@/views/transferManagement/withdrawList.vue')
        },
        {
          path: 'withdrawCashConfirm',
          meta: {
            title: '提现确认页'
          },
          name: 'withdrawCashConfirm',
          component: () => import('@/views/transferManagement/components/withdrawCashConfirm.vue')
        }
      ]
    },
    // 门店账户管理
    {
      path: '/branchAccountManagement',
      component: Main,
      redirect: '/branchAccountManagement/accountIncoming',
      children: [
        {
          path: 'accountIncoming',
          meta: {
            title: '账户收入'
          },
          name: 'accountIncoming',
          component: () => import('@/views/branchAccountManagement/accountIncoming.vue')
        },
        {
          path: 'accountIncoming/incomeDetail',
          meta: {
            title: '账户收入明细'
          },
          name: 'incomeDetail',
          component: () => import('@/views/branchAccountManagement/incomeDetail.vue')
        },
        {
          path: 'accountFee',
          meta: {
            title: '账户费用'
          },
          name: 'accountFee',
          component: () => import('@/views/branchAccountManagement/accountFee.vue')
        },
        {
          path: 'accountFee/feeDetail',
          meta: {
            title: '账户费用详情'
          },
          name: 'feeDetail',
          component: () => import('@/views/branchAccountManagement/feeDetail.vue')
        },
        {
          path: 'accountBalance',
          meta: {
            title: '账户余额'
          },
          name: 'accountBalance',
          component: () => import('@/views/branchAccountManagement/accountBalance.vue')
        },
        {
          path: 'accountBalance/historyList',
          meta: {
            title: '历史月结余额'
          },
          name: 'historyList',
          component: () => import('@/views/branchAccountManagement/historyList.vue')
        },
        {
          path: 'internalTransferList',
          meta: {
            title: '漫游转账发起',
            keepAlive: true
          },
          name: 'internalTransferList',
          component: () => import('@/views/branchAccountManagement/internalTransferList.vue')
        },
        {
          path: 'batchDocumentsDetail/:importId',
          meta: {
            title: '批次单据详情'
          },
          name: 'batchDocumentsDetail',
          component: () => import('@/views/branchAccountManagement/components/batchDocumentsDetail.vue')
        },
        {
          path: 'internalOneTransferList',
          meta: {
            title: '余额转出列表'
          },
          name: 'internalOneTransferList',
          component: () => import('@/views/branchAccountManagement/internalOneTransferList.vue')
        },
        {
          path: 'internalTransferApprove',
          meta: {
            title: '内部转账审核',
            keepAlive: true
          },
          name: 'internalTransferApprove',
          component: () => import('@/views/branchAccountManagement/internalTransferApprove/index.vue')
        }
      ]
    },
    // 门店记账
    {
      path: '/branchChargeAccount',
      component: Main,
      redirect: '/branchChargeAccount/chargeAccountManagement',
      children: [
        {
          path: 'chargeAccountManagement',
          meta: {
            title: '门店记账'
          },
          name: 'chargeAccountManagement',
          component: () => import('@/views/branchChargeAccount/chargeAccountManagement.vue')
        },
        {
          path: 'chargeAccountManagement/accountFreeze',
          meta: {
            title: '冻结'
          },
          name: 'accountFreeze',
          component: () => import('@/views/branchChargeAccount/freeze.vue')
        },
        {
          path: 'chargeAccountManagement/accountThaw',
          meta: {
            title: '解冻'
          },
          name: 'accountThaw',
          component: () => import('@/views/branchChargeAccount/thaw.vue')
        },
        {
          path: 'chargeAccountManagement/accountDetail',
          meta: {
            title: '明细'
          },
          name: 'accountDetail',
          component: () => import('@/views/branchChargeAccount/accountDetail.vue')
        },
        {
          path: 'chargeAccountManagement/operationRecords',
          meta: {
            title: '操作记录'
          },
          name: 'operationRecords',
          component: () => import('@/views/branchChargeAccount/operationRecords.vue')
        },
        {
          path: 'branchDailyBalance',
          meta: {
            title: '日结查询'
          },
          name: 'branchDailyBalance',
          component: () => import('@/views/branchChargeAccount/branchDailyBalance.vue')
        }

      ]
    },
    // 系统设置
    {
      path: '/systemConfig',
      component: Main,
      redirect: '/systemConfig/roleManagement',
      children: [
        {
          path: 'roleManagement',
          meta: {
            title: '角色管理'
          },
          name: 'roleManagement',
          component: () => import('@/views/systemConfig/roleManagement.vue')
        },
        {
          path: 'flowManagement',
          meta: {
            title: '审批流管理'
          },
          name: 'flowManagement',
          component: () => import('@/views/systemConfig/flow/index.vue')
        },
        {
          path: 'flowManagement/flowConfig',
          meta: {
            title: '配置审批流'
          },
          name: 'flowConfig',
          component: () => import('@/views/systemConfig/flow/config.vue')
        },
        {
          path: 'flowManagement/flowDetail',
          meta: {
            title: '审批流详情'
          },
          name: 'flowDetail',
          component: () => import('@/views/systemConfig/flow/config.vue')
        }
      ]
    }
  ]
})

const whiteList = ['login', 'Main', 'callBack', ''];// 不重定向白名单(包括登录页)
let pageLoading = null;
router.beforeEach((to, from, next) => {
  pageLoading = Loading.service({fullscreen: true});
  Util.title(to.meta.title);

  // 列表页全局搜索条件状态保持 (无父子路由关系，清除to缓存的页面搜索条件)
  if (!(from && to && Util.checkParentChildRoutePath(to.fullPath, from.fullPath))) {
    // 删除列表页搜索条件缓存
    store.dispatch('deleteSearchModelMapAct', to.name);
    // 删除tab页面搜索缓存
    let allKeys = store.state.app.searchModelMap.keys();
    let currentKey = allKeys.next();
    do {
      if (currentKey.value) {
        if (currentKey.value.indexOf(`${to.name}:`) === 0) {
          store.dispatch('deleteSearchModelMapAct', currentKey.value);
        }
      }
      currentKey = allKeys.next();
    } while (!currentKey.done);
  }

  if (getToken() && whiteList.indexOf(to.name) === -1) {
    if (to.name === 'login') {
      next({name: 'home'});
    } else {
      if (store.state.user.userInfo === null) {
        store.dispatch('GetInfo').then(() => {
          next();
        }).catch((err) => {
          if (err.status === 500 && err.message) {
            Message.error(err.message);
          }
          setTimeout(() => { pageLoading.close(); }, 500);
          next({
            name: 'login'
          });
        });
      } else {
        next();
      }
    }
  } else {
    if (whiteList.indexOf(to.name) !== -1) { // 在免登录白名单，直接进入
      next();
    } else {
      next({name: 'login'}); // 否则全部重定向到登录页
    }
  }
});

router.afterEach((to) => {
  // 解决刷新页面时菜单定位问题
  router.app.$store.commit('updateMenulist');
  Util.openNewPage(router.app, to.name, to.params, to.query, to.fullPath);
  setTimeout(() => { pageLoading.close(); }, 500);
  // iView.LoadingBar.finish();
  window.scrollTo(0, 0);
});

router.onError((error) => {
  console.log('router error:', error.message);
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    console.log('loading chunk failed:', targetPath);
    MessageBox.alert('有新版本发布，请立即执行刷新操作', '提示', {
      confirmButtonText: '刷  新',
      callback: () => {
        window.location.reload();
      }
    })
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js